import { render, staticRenderFns } from "./VisitPassesTemplate.vue?vue&type=template&id=32ad7c90&"
import script from "./VisitPassesTemplate.vue?vue&type=script&lang=js&"
export * from "./VisitPassesTemplate.vue?vue&type=script&lang=js&"
import style0 from "./VisitPassesTemplate.vue?vue&type=style&index=0&id=32ad7c90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports